export const DAYS_IN_GRAPH_FULL_TIME = 1;
export const DAYS_IN_GRAPH_WORK_HOURS = 3;
export const MAX_BARS_IN_FULL_DAY = 48;
export const MAX_BARS_IN_GRAPH = 66;
export const MAX_BARS_FOR_HOURS = 33;
export const MAX_BARS_FOR_DAYS = 15;
export const MAX_BARS_IN_COMBINED_OCCUPANCY = 65;
